import styled from 'styled-components';
import {
  alignItems,
  flexDirection,
  flexWrap,
  justifyContent,
} from 'styled-system';

import { Box } from 'components/Box';

const Flex = styled(Box)`
  display: flex;
  ${flexWrap} ${flexDirection} ${alignItems} ${justifyContent};
`;
// eslint-disable-next-line import/no-default-export
export default Flex;
